import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { LoanPurposeType } from "Globals/Models/LoanPurposeType";
import { LendersEnum } from "Globals/Models/LendersEnum";

export class LoanPurposeTypesStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private loanPurposeTypes: LoanPurposeType[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.loanPurposeTypes = initialState.loanPurposeTypes;
    }

    @MobX.action
    public getPurposeName(purposeId: string | null): string {
        if (purposeId == null) return "";
        let purpose = this.getSortedByOrdinal.find((purpose) => purposeId === purpose.id);
        return purpose ? purpose.name : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): LoanPurposeType[] {
        return this.loanPurposeTypes.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getLoanPurposeTypeOptions(): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "0",
        } as KeyValuePair;

        let options = this.getSortedByOrdinal.map((lender) => ({ value: lender.id, key: lender.name })) as KeyValuePair[];

        options.unshift(placeholder);

        return options;
    }
}
